<template>
    <v-card class="pa-4 box_shadow_class mt-0">
      <div>
        <div>
          <span>
            <HeaderComponent :headerTitle="headerText" />
          </span>
        </div>
        <v-container class="ma-0 pa-0" fluid grid-list-lg>
          <v-layout class="ma-0 pa-0" row wrap>
            <!-- <v-flex class xs12 style="background-color: grey lighten-3"> -->
              <v-row>
                <!-- <v-col xs3 cols="3" sm="3" md="3">
                  <router-link :to="{ name: 'd2c_return_approval' }">
                    <v-card class="pa-4 box_shadow_class">
                      <div align="center" justify="center">
                        <img class="mt-3" src="@/assets/images/icons/inward-icons/inward-tracking.png" width="108" height="108" />
                      </div>
                      <div class="mt-3 text-color" align="center" justify="center">
                        D2C Return Approval
                      </div>
                    </v-card>
                  </router-link>
                </v-col>                -->
                <!-- <v-col xs3 cols="3" sm="3" md="3">
                  <router-link :to="{ name: 'pull_back_return_approval' }">
                    <v-card class="pa-4 box_shadow_class">
                      <div align="center" justify="center">
                        <img class="mt-3" src="@/assets/images/icons/returns_creation_.svg" width="108" height="108" />
                      </div>
                      <div class="mt-3 text-color" align="center" justify="center">
                        Pull Back Return Approval
                      </div>
                    </v-card>
                  </router-link>
                </v-col> -->
                <v-col xs3 cols="3" sm="3" md="3" class="ml-2">
                  <router-link :to="{ name: 'warranty_claim_approval' }">
                    <v-card class="pa-4 box_shadow_class">
                      <div align="center" justify="center">
                        <img class="mt-3" src="@/assets/images/icons/return_approval.svg" width="108" height="108" />
                      </div>
                      <div class="mt-3 text-color responsive-text" align="center" justify="center">
                        {{(organization_name === 'Voltas' || organization_name === 'Crompton') ? 'Customer Case' : 'Warranty Claim Approval'}}
                      </div>
                    </v-card>
                  </router-link>
                </v-col>
                <v-col xs3 cols="3" sm="3" md="3">
                  <router-link :to="{ name: 'dealer_partner_return_approval' }">
                    <v-card class="pa-4 box_shadow_class">
                      <div align="center" justify="center">
                        <img class="mt-3" src="@/assets/images/icons/return_approval.svg" width="108" height="108" />
                      </div>
                      <div class="mt-3 text-color responsive-text" align="center" justify="center">
                        {{(organization_name === 'Voltas' || organization_name === 'Crompton') ? 'Dealer Case' : 'Warranty Claim Approval'}}
                      </div>
                    </v-card>
                  </router-link>
                </v-col>
                <!-- <v-col xs3 cols="3" sm="3" md="3">
                  <router-link :to="{ name: 'internal_return_approval' }">
                    <v-card class="pa-4 box_shadow_class">
                      <div align="center" justify="center">
                        <img class="mt-3" src="@/assets/images/icons/return_approval.svg" width="108" height="108" />
                      </div>
                      <div class="mt-3 text-color" align="center" justify="center">
                        Internal Return Approval
                      </div>
                    </v-card>
                  </router-link>
                </v-col> -->
              </v-row>
              <!-- <v-row>
                <v-col xs3 cols="3" sm="3" md="3">
                  <router-link :to="{ name: 'dealer_partner_return_approval' }">
                    <v-card class="pa-4 box_shadow_class">
                      <div align="center" justify="center">
                        <img class="mt-3" src="@/assets/images/icons/returns_creation_.svg" width="108" height="108" />
                      </div>
                      <div class="mt-3 text-color" align="center" justify="center">
                        Delaer/Partner Return Approval
                      </div>
                    </v-card>
                  </router-link>
                </v-col>
              </v-row> -->
            <!-- </v-flex> -->
          </v-layout>
        </v-container>
      </div>
    </v-card>
  </template>
  
  <script>
    import HeaderComponent from "./../../../commoncomponents/HeaderComponent.vue";
    import { mapState } from "vuex"
    export default {
      data() {
        return {
          headerText: "Returns",
          alert: false,
          alert_message:'',
        };
      },
  
      components: {
        HeaderComponent,
      },
  
      computed: mapState(["currentUser", "signedIn"]),
  
      created() { this.organization_name = this.$store.state.organization_name },
  
      methods: {},
    };
  </script>
  <style scoped>
  .responsive-text {
    font-size: 16px; /* Default size */
  }
  @media (max-width: 1400px) {
    .responsive-text {
      font-size: 14px !important;
    }
  }
  .v-layout {
    height: calc(var(--vh, 1vh) * 100 - 130px) !important;
  }
  </style>